import axios from "axios";
import environments from "../Utils/Environment";
import { setHeaderMessage } from "../Services/DashboardHeader/uiSlice";

const apiUrlStaging = environments.local.url;

const axiosInstance = axios.create({
  baseURL: apiUrlStaging,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    if (response?.status === 401 && response?.statusText === "Unauthorized") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_type");
      localStorage.removeItem("user_first_name");
      localStorage.removeItem("user_last_name");
      localStorage.removeItem("refresh-token");

      const { default: store } = await import("../Redux/store"); // Dynamically import the store
      store.dispatch(setHeaderMessage("Community Management"));
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
